import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { ITitleMultiImageText, IItem } from './types';
import { RichText } from 'prismic-reactjs';
import { Image } from './Image';
import { Text } from './Text';
import withSlice from '../withSlice';
import { mapTitleMultiImageText } from './mapTitleMultiImageText';

/**
 * Props for `TitleMultiImageText`.
 */
export type TitleMultiImageTextProps =
  SliceComponentProps<Content.TitleMultiImageTextSlice>;

const TitleMultiImageText: React.FC<ITitleMultiImageText> = ({
  items,
  title,
}) => {
  return (
    <section className="root">
      <RichText render={title} />
      <div className="container">
        {items.map((item: IItem, index: number) => {
          return (
            <div key={index}>
              {item.image ? (
                <Image key={index} image={item.image} alt={item.alt!} />
              ) : (
                <Text key={index} title={item.title!} text={item.text!} />
              )}
            </div>
          );
        })}
      </div>
      <style jsx>{`
        .root :global(h1) {
          margin-bottom: 40px;
        }

        .root :global(h2) {
          margin-bottom: var(--space-4);
        }

        .container {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-gap: 20px;
        }

        @media (max-width: 800px) {
          .container {
            grid-template-columns: repeat(1, 1fr);
          }
        }
      `}</style>
    </section>
  );
};

export default withSlice(TitleMultiImageText, mapTitleMultiImageText);
